import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoginRoutingModule } from './login.routing';
import { LoginService } from 'src/app/services/login.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    LoginRoutingModule,
    NgbModule
  ],
  providers: [LoginService]
})
export class LoginModule { }
